import {
  Database, FileText, AlertTriangle, ClipboardCheck, Briefcase,
  ShieldOff, RefreshCw, Sparkles, Settings, Camera, BarChart3, ListChecks, Link2, Activity, Upload,
  Building2, Shield, FileCheck, FolderKanban, Cog, FileWarning,
} from 'lucide-react';
import type { NavItem, NavGroup } from '../types/navigation';

export const NAV_ITEMS: NavItem[] = [
  {
    key: 'var',
    label: 'Data Lake',
    path: '/var',
    icon: Database,
    group: 'standalone',
  },
  { key: 'policies', label: 'Policies', path: '/policies', icon: FileText, group: 'risk' },
  { key: 'findings', label: 'Findings', path: '/findings', icon: AlertTriangle, group: 'underwriting' },
  { key: 'buildings', label: 'Buildings', path: '/buildings', icon: Building2, group: 'risk' },
  { key: 'inspections', label: 'Inspections', path: '/inspections', icon: ClipboardCheck, group: 'risk' },
  { key: 'secure-links', label: 'Secure Links', path: '/secure-links', icon: Link2, roles: ['broker', 'admin'], group: 'risk', testId: 'secure-links-nav' },
  { key: 'inspection-jobs', label: 'Inspection Jobs', path: '/inspection-jobs', icon: Briefcase, roles: ['admin', 'underwriter', 'broker'], group: 'risk' },
  { key: 'inspector-dashboard', label: 'Inspector Dashboard', path: '/inspector-dashboard', icon: Activity, group: 'risk' },
  { key: 'photos', label: 'Photo Search', path: '/photos', icon: Camera, group: 'risk' },
  { key: 'portfolio-analytics', label: 'Portfolio Analytics', path: '/portfolio-analytics', icon: BarChart3, roles: ['underwriter', 'admin'], group: 'risk' },
  { key: 'subjectivities', label: 'Subjectivities', path: '/subjectivities', icon: ListChecks, group: 'underwriting' },
  { key: 'exceptions', label: 'Findings Review', path: '/exceptions', icon: ShieldOff, group: 'underwriting' },
  { key: 'import', label: 'Import Portfolio', path: '/import', icon: Upload, roles: ['broker', 'admin'], group: 'management', testId: 'import-link' },
  { key: 'renewals', label: 'Renewals', path: '/renewals', icon: RefreshCw, roles: ['broker', 'admin'], group: 'management' },
  { key: 'claims', label: 'Claims', path: '/claims', icon: FileWarning, roles: ['underwriter', 'admin'], group: 'underwriting' },
  { key: 'uw-review', label: 'UW Review Queue', path: '/uw-review', icon: ClipboardCheck, roles: ['underwriter', 'admin'], group: 'underwriting' },
  { key: 'ai-analysis', label: 'AI Analysis', path: '/ai-analysis', icon: Sparkles, badge: 'preview', group: 'management' },
  { key: 'admin', label: 'Admin', path: '/admin', icon: Settings, roles: ['admin'], group: 'system' },
];

export const NAV_GROUPS: NavGroup[] = [
  { key: 'risk', label: 'Risk Assessment', icon: Shield, items: NAV_ITEMS.filter(i => i.group === 'risk') },
  { key: 'underwriting', label: 'Underwriting', icon: FileCheck, items: NAV_ITEMS.filter(i => i.group === 'underwriting') },
  { key: 'management', label: 'Management', icon: FolderKanban, items: NAV_ITEMS.filter(i => i.group === 'management') },
  { key: 'system', label: 'System', icon: Cog, items: NAV_ITEMS.filter(i => i.group === 'system') },
];
